module.exports = __webpack_public_path__ + "static/img/login-pic.73ff854.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login-pic.png
// module id = lLGD
// module chunks = 1